import React from 'react';
import { config } from '@keytrade/functions';

const { list: colors } = config.colors;

const YouTubeIcon: React.FC = () => {
  return (
    <svg
      width='25'
      height='23'
      viewBox='0 0 25 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-label='YouTube'
    >
      <path
        d='M6.43088 2.00668C5.12444 2.1315 3.90649 2.62721 2.97565 3.41302C2.04479 4.1988 1.45597 5.22832 1.30517 6.33368C1.08231 8.01544 0.892883 9.73964 0.892883 11.5C0.892883 13.2604 1.08231 14.9861 1.30517 16.6663C1.45597 17.7716 2.04479 18.8012 2.97565 19.587C3.90649 20.3729 5.12444 20.8686 6.43088 20.9934C8.40503 21.1725 10.433 21.3234 12.5 21.3234C14.567 21.3234 16.595 21.1725 18.5711 20.9934C19.8775 20.8686 21.0954 20.3729 22.0263 19.587C22.9572 18.8012 23.5459 17.7716 23.6968 16.6663C23.9159 14.9845 24.1072 13.2604 24.1072 11.5C24.1072 9.73964 23.9177 8.01387 23.6949 6.33368C23.5441 5.22832 22.9552 4.1988 22.0245 3.41302C21.0936 2.62721 19.8756 2.1315 18.5691 2.00668C16.5969 1.8275 14.5689 1.67661 12.5 1.67661C10.4312 1.67661 8.40503 1.8275 6.43088 2.00668Z'
        stroke={colors.BlueDawn}
        strokeWidth='1.77778'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.41 15.8936C13.7085 14.689 17.0166 12.74 17.0166 11.5001C17.0166 10.2601 13.7085 8.31113 11.41 7.10654C10.347 6.54945 9.08683 7.23803 8.99543 8.43469C8.83884 10.4848 8.83884 12.5153 8.99543 14.5654C9.08683 15.7621 10.347 16.4507 11.41 15.8936Z'
        stroke={colors.BlueDawn}
        strokeWidth='1.77778'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default YouTubeIcon;
